const SUPPORT_EMAIL = 'hello@fontawesome.com'
const FEEDBACK_EMAIL = 'feedback@fontawesome.com'

const SUPPORT_SUBJECT = "I'm having a technical issue, Font Awesome!"
const SUPPORT_CANCEL_FAILED_SUBJECT = "My cancel didn't go through, Font Awesome!"

const FEEDBACK_SUBJECTS = {
  pricing: 'I have feedback about pricing, Font Awesome!',
  missing_feature: "I'm missing something specific, Font Awesome!"
}

const ACCOUNT_EMAIL_FALLBACK = '[account email unavailable]'
const PLAN_NAME_FALLBACK = '[plan unavailable]'
const SUBSCRIPTION_END_FALLBACK = 'your current billing period'

function buildContextBlock({ accountEmail, planName, subscriptionEndDate }) {
  return [
    `Account: ${accountEmail || ACCOUNT_EMAIL_FALLBACK}`,
    `Plan: ${planName || PLAN_NAME_FALLBACK}`,
    `Subscription ends: ${subscriptionEndDate || SUBSCRIPTION_END_FALLBACK}`
  ].join('\n')
}

function buildMailto(recipient, subject, body) {
  const params = `subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
  return `mailto:${recipient}?${params}`
}

export function buildSupportMailto({ accountEmail, planName, subscriptionEndDate, reason } = {}) {
  const subject = reason === 'cancel_failed' ? SUPPORT_CANCEL_FAILED_SUBJECT : SUPPORT_SUBJECT

  const body = [buildContextBlock({ accountEmail, planName, subscriptionEndDate }), '', "Describe what's not working:", ''].join('\n')

  return buildMailto(SUPPORT_EMAIL, subject, body)
}

export function buildFeedbackMailto({ topic, accountEmail } = {}) {
  const subject = FEEDBACK_SUBJECTS[topic] || FEEDBACK_SUBJECTS.missing_feature

  const body = [`Account: ${accountEmail || ACCOUNT_EMAIL_FALLBACK}`, '', ''].join('\n')

  return buildMailto(FEEDBACK_EMAIL, subject, body)
}
